module.exports = __webpack_public_path__ + "img/pr-11.223fac01.png";